import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Transición Bootstrap → Tailwind: la capa de compatibilidad y luego Tailwind.
// El orden importa (Tailwind al final gana a igualdad de especificidad).
import './theme-compat.css';
import './tailwind.css';
import { SistemaSeguridadApp } from './app/SistemaSeguridadApp';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  // <React.StrictMode>
    <BrowserRouter>
      <SistemaSeguridadApp />
    </BrowserRouter>
  // </React.StrictMode>
);


